export let TealiumStages = /*#__PURE__*/function (TealiumStages) {
  TealiumStages["PROD"] = "prod";
  TealiumStages["QA"] = "qa";
  TealiumStages["DEV"] = "dev";
  return TealiumStages;
}({});
export let TealiumProfiles = /*#__PURE__*/function (TealiumProfiles) {
  TealiumProfiles["INT_DE"] = "int-de";
  TealiumProfiles["EHYP_DE"] = "ehyp-de";
  TealiumProfiles["PRO_DE"] = "pro-de";
  TealiumProfiles["CREDIT_DE"] = "credit-de";
  TealiumProfiles["GRU_DE"] = "gru-de";
  return TealiumProfiles;
}({});
export const getTealiumScriptUrl = (stage, profile = TealiumProfiles.INT_DE) => {
  return `//tags.tiqcdn.com/utag/interhyp/${profile}/${stage}/utag.js`;
};